
export const directoryCategories = [
  { id: 'all', name: 'All Businesses', icon: 'ri-store-2-line', count: 18 },
  { id: 'restaurant', name: 'Restaurants', icon: 'ri-restaurant-line', count: 4 },
  { id: 'retail', name: 'Retail & Shopping', icon: 'ri-shopping-bag-line', count: 3 },
  { id: 'health', name: 'Health & Wellness', icon: 'ri-heart-pulse-line', count: 3 },
  { id: 'home', name: 'Home Services', icon: 'ri-home-gear-line', count: 2 },
  { id: 'professional', name: 'Professional', icon: 'ri-briefcase-line', count: 2 },
  { id: 'auto', name: 'Automotive', icon: 'ri-car-line', count: 2 },
  { id: 'beauty', name: 'Beauty & Spa', icon: 'ri-scissors-line', count: 1 },
  { id: 'education', name: 'Education', icon: 'ri-book-open-line', count: 1 },
];

export const directoryBusinesses = [
  {
    id: 1,
    name: 'Roseville Family Dental',
    tagline: 'Your smile is our passion',
    category: 'health',
    description: 'Comprehensive family dentistry serving Roseville for over 20 years. From routine cleanings to cosmetic procedures, we provide gentle, personalized care for patients of all ages.',
    address: '1234 Douglas Blvd, Roseville, CA 95678',
    phone: '(916) 555-0142',
    website: 'https://rosevillefamilydental.com',
    image: 'https://public.readdy.ai/ai/img_res/b0a2ff6c764777e210b8d2c2a9278104.jpg',
    logo: 'ri-tooth-line',
    rating: 4.9,
    reviews: 312,
    featured: true,
    verified: true,
    offer: '20% Off First Visit',
    openNow: true,
    hours: 'Mon-Fri 8AM-6PM',
    priceRange: '$$',
    yearEstablished: 2003,
    lastVerified: 'Mar 12, 2025',
  },
  {
    id: 2,
    name: 'Sierra Auto Works',
    tagline: 'Trusted auto repair since 2005',
    category: 'auto',
    description: 'Full-service auto repair and maintenance shop specializing in both domestic and import vehicles. ASE-certified technicians, honest pricing, and a comfortable waiting area.',
    address: '890 Riverside Ave, Roseville, CA 95678',
    phone: '(916) 555-0198',
    website: 'https://sierraautoworks.com',
    image: 'https://readdy.ai/api/search-image?query=modern%20auto%20repair%20shop%20exterior%20with%20clean%20professional%20look%20well%20organized%20garage%20bays%20with%20cars%20being%20serviced%20bright%20signage%20and%20tidy%20parking%20lot%20suburban%20California%20setting&width=600&height=400&seq=ad2&orientation=landscape',
    logo: 'ri-car-washing-line',
    rating: 4.8,
    reviews: 187,
    featured: true,
    verified: true,
    offer: 'Free Brake Inspection',
    openNow: true,
    hours: 'Mon-Sat 7AM-6PM',
    priceRange: '$$',
    yearEstablished: 2005,
    lastVerified: 'Mar 8, 2025',
  },
  {
    id: 3,
    name: 'Bloom & Vine Florist',
    tagline: 'Handcrafted arrangements for every occasion',
    category: 'retail',
    description: 'A charming local florist offering stunning fresh flower arrangements, wedding florals, event decor, and weekly subscription bouquets sourced from Northern California farms.',
    address: '456 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0267',
    website: 'https://bloomandvine.com',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20flower%20shop%20interior%20with%20colorful%20fresh%20bouquets%20and%20arrangements%20on%20rustic%20wooden%20shelves%20warm%20lighting%20charming%20boutique%20florist%20with%20greenery%20and%20seasonal%20flowers%20cozy%20atmosphere&width=600&height=400&seq=ad3&orientation=landscape',
    logo: 'ri-plant-line',
    rating: 4.9,
    reviews: 156,
    featured: true,
    verified: true,
    offer: '15% Off Wedding Packages',
    openNow: true,
    hours: 'Mon-Sat 9AM-7PM',
    priceRange: '$$',
    yearEstablished: 2015,
    lastVerified: 'Mar 10, 2025',
  },
  {
    id: 4,
    name: 'Placer Fitness Studio',
    tagline: 'Transform your body, elevate your mind',
    category: 'health',
    description: 'Boutique fitness studio offering yoga, pilates, HIIT, and spin classes. Small class sizes, expert instructors, and a supportive community atmosphere.',
    address: '2100 Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0334',
    website: 'https://placerfitness.com',
    image: 'https://readdy.ai/api/search-image?query=modern%20boutique%20fitness%20studio%20interior%20with%20yoga%20mats%20and%20exercise%20equipment%20bright%20natural%20light%20through%20large%20windows%20clean%20minimalist%20gym%20design%20with%20wooden%20floors%20and%20mirrors&width=600&height=400&seq=ad4&orientation=landscape',
    logo: 'ri-run-line',
    rating: 4.7,
    reviews: 243,
    featured: false,
    verified: true,
    offer: 'First Class Free',
    openNow: true,
    hours: 'Mon-Sun 5AM-9PM',
    priceRange: '$$',
    yearEstablished: 2018,
    lastVerified: 'Feb 28, 2025',
  },
  {
    id: 5,
    name: 'Roseville Pizza Kitchen',
    tagline: 'Wood-fired perfection since 2012',
    category: 'restaurant',
    description: 'Artisan wood-fired pizzas made with locally sourced ingredients, craft beers on tap, and a family-friendly patio. Known for our signature Roseville Supreme and garlic knots.',
    address: '780 Pleasant Grove Blvd, Roseville, CA 95678',
    phone: '(916) 555-0411',
    website: 'https://rosevillepizzakitchen.com',
    image: 'https://readdy.ai/api/search-image?query=cozy%20artisan%20pizza%20restaurant%20interior%20with%20wood%20fired%20oven%20visible%20in%20background%20warm%20ambient%20lighting%20rustic%20Italian%20decor%20with%20exposed%20brick%20walls%20and%20wooden%20tables%20inviting%20dining%20atmosphere&width=600&height=400&seq=ad5&orientation=landscape',
    logo: 'ri-restaurant-2-line',
    rating: 4.6,
    reviews: 428,
    featured: false,
    verified: true,
    offer: '',
    openNow: true,
    hours: 'Mon-Sun 11AM-10PM',
    priceRange: '$$',
    yearEstablished: 2012,
    lastVerified: 'Feb 20, 2025',
  },
  {
    id: 6,
    name: 'Green Thumb Landscaping',
    tagline: 'Creating outdoor living spaces',
    category: 'home',
    description: 'Full-service landscaping company offering design, installation, and maintenance. Specializing in drought-tolerant California native gardens, hardscaping, and outdoor kitchens.',
    address: '3200 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 555-0523',
    website: 'https://greenthumbroseville.com',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20landscaped%20front%20yard%20in%20California%20suburban%20home%20with%20drought%20tolerant%20native%20plants%20stone%20pathway%20green%20lawn%20and%20mature%20trees%20professional%20garden%20design%20sunny%20day&width=600&height=400&seq=ad6&orientation=landscape',
    logo: 'ri-leaf-line',
    rating: 4.8,
    reviews: 98,
    featured: false,
    verified: true,
    offer: 'Free Design Consultation',
    openNow: false,
    hours: 'Mon-Fri 7AM-5PM',
    priceRange: '$$$',
    yearEstablished: 2010,
    lastVerified: 'Mar 1, 2025',
  },
  {
    id: 7,
    name: 'Summit Financial Advisors',
    tagline: 'Building wealth, securing futures',
    category: 'professional',
    description: 'Independent financial planning firm helping Roseville families with retirement planning, investment management, tax strategies, and estate planning for over 15 years.',
    address: '1500 Eureka Rd Suite 200, Roseville, CA 95661',
    phone: '(916) 555-0678',
    website: 'https://summitfinancialroseville.com',
    image: 'https://readdy.ai/api/search-image?query=modern%20professional%20financial%20office%20interior%20with%20elegant%20desk%20and%20comfortable%20client%20chairs%20bookshelf%20with%20financial%20books%20large%20windows%20with%20city%20view%20clean%20corporate%20design%20warm%20tones&width=600&height=400&seq=ad7&orientation=landscape',
    logo: 'ri-line-chart-line',
    rating: 4.9,
    reviews: 67,
    featured: false,
    verified: true,
    offer: '',
    openNow: false,
    hours: 'Mon-Fri 9AM-5PM',
    priceRange: '$$$',
    yearEstablished: 2008,
    lastVerified: 'Feb 15, 2025',
  },
  {
    id: 8,
    name: 'Roseville Pet Paradise',
    tagline: 'Where pets are family',
    category: 'retail',
    description: 'Premium pet supply store and grooming salon. We carry organic pet food, eco-friendly toys, and offer professional grooming, nail trimming, and puppy socialization classes.',
    address: '620 N Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0789',
    website: 'https://rosevillepetparadise.com',
    image: 'https://readdy.ai/api/search-image?query=bright%20cheerful%20pet%20store%20interior%20with%20colorful%20pet%20supplies%20on%20shelves%20dog%20grooming%20area%20visible%20clean%20modern%20retail%20space%20with%20friendly%20atmosphere%20pet%20toys%20and%20accessories%20displayed%20neatly&width=600&height=400&seq=ad8&orientation=landscape',
    logo: 'ri-bear-smile-line',
    rating: 4.7,
    reviews: 201,
    featured: false,
    verified: true,
    offer: '10% Off Grooming',
    openNow: true,
    hours: 'Mon-Sat 9AM-8PM, Sun 10AM-6PM',
    priceRange: '$$',
    yearEstablished: 2016,
    lastVerified: 'Mar 5, 2025',
  },
  {
    id: 9,
    name: 'Craft & Cork Wine Bar',
    tagline: 'Sip, savor, socialize',
    category: 'restaurant',
    description: 'Upscale wine bar featuring an extensive selection of California wines, artisan cheese boards, and small plates. Live music on weekends and private event space available.',
    address: '410 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0856',
    website: 'https://craftandcork.com',
    image: 'https://readdy.ai/api/search-image?query=elegant%20wine%20bar%20interior%20with%20exposed%20brick%20walls%20wine%20bottles%20displayed%20on%20wooden%20racks%20ambient%20warm%20lighting%20comfortable%20bar%20seating%20sophisticated%20atmosphere%20with%20cheese%20board%20on%20counter&width=600&height=400&seq=ad9&orientation=landscape',
    logo: 'ri-goblet-line',
    rating: 4.8,
    reviews: 176,
    featured: false,
    verified: false,
    offer: '',
    openNow: true,
    hours: 'Tue-Sun 4PM-11PM',
    priceRange: '$$$',
    yearEstablished: 2019,
    lastVerified: 'Jan 22, 2025',
  },
  {
    id: 10,
    name: 'Sunrise Yoga & Meditation',
    tagline: 'Find your inner peace',
    category: 'health',
    description: 'A tranquil yoga studio offering Vinyasa, Hatha, Yin, and meditation classes for all levels. Private sessions, teacher training, and wellness workshops available year-round.',
    address: '1850 Cirby Way, Roseville, CA 95661',
    phone: '(916) 555-0912',
    website: 'https://sunriseyogaroseville.com',
    image: 'https://readdy.ai/api/search-image?query=serene%20yoga%20studio%20interior%20with%20bamboo%20floors%20soft%20natural%20lighting%20meditation%20cushions%20and%20plants%20peaceful%20zen%20atmosphere%20with%20large%20windows%20and%20warm%20earth%20tones%20calming%20wellness%20space&width=600&height=400&seq=dir10&orientation=landscape',
    logo: 'ri-mental-health-line',
    rating: 4.9,
    reviews: 189,
    featured: false,
    verified: true,
    offer: '2 Weeks Unlimited $29',
    openNow: true,
    hours: 'Mon-Sun 6AM-8PM',
    priceRange: '$$',
    yearEstablished: 2017,
    lastVerified: 'Mar 14, 2025',
  },
  {
    id: 11,
    name: 'Roseville Brewing Co.',
    tagline: 'Craft beer, community spirit',
    category: 'restaurant',
    description: 'Local craft brewery and taproom with 16 rotating taps, seasonal releases, and a full food menu. Dog-friendly patio, trivia nights, and live music every Friday.',
    address: '501 Derek Pl, Roseville, CA 95678',
    phone: '(916) 555-0934',
    website: 'https://rosevillebrewing.com',
    image: 'https://readdy.ai/api/search-image?query=modern%20craft%20brewery%20taproom%20interior%20with%20industrial%20decor%20exposed%20beams%20copper%20brewing%20tanks%20visible%20through%20glass%20wall%20wooden%20bar%20with%20beer%20taps%20warm%20lighting%20community%20gathering%20space&width=600&height=400&seq=dir11&orientation=landscape',
    logo: 'ri-cup-line',
    rating: 4.7,
    reviews: 342,
    featured: false,
    verified: true,
    offer: 'Happy Hour 3-6PM Daily',
    openNow: true,
    hours: 'Mon-Thu 11AM-10PM, Fri-Sat 11AM-12AM, Sun 10AM-9PM',
    priceRange: '$$',
    yearEstablished: 2020,
    lastVerified: 'Mar 11, 2025',
  },
  {
    id: 12,
    name: 'Precision Tire & Wheel',
    tagline: 'Rolling you forward safely',
    category: 'auto',
    description: 'Family-owned tire shop offering premium tire brands, wheel alignment, balancing, and brake services. Price match guarantee and free tire rotation with purchase.',
    address: '2400 Harding Blvd, Roseville, CA 95678',
    phone: '(916) 555-1023',
    website: 'https://precisiontireroseville.com',
    image: 'https://readdy.ai/api/search-image?query=clean%20professional%20tire%20shop%20interior%20with%20rows%20of%20new%20tires%20on%20display%20racks%20modern%20automotive%20service%20center%20bright%20fluorescent%20lighting%20organized%20workspace%20with%20wheel%20alignment%20equipment&width=600&height=400&seq=dir12&orientation=landscape',
    logo: 'ri-settings-3-line',
    rating: 4.6,
    reviews: 134,
    featured: false,
    verified: true,
    offer: '$50 Off Set of 4 Tires',
    openNow: true,
    hours: 'Mon-Sat 7:30AM-5:30PM',
    priceRange: '$$',
    yearEstablished: 2009,
    lastVerified: 'Feb 25, 2025',
  },
  {
    id: 13,
    name: 'Luxe Salon & Spa',
    tagline: 'Indulge in self-care',
    category: 'beauty',
    description: 'Full-service luxury salon and day spa offering haircuts, color, facials, massages, manicures, and bridal packages. Award-winning stylists in a relaxing atmosphere.',
    address: '1100 Galleria Blvd Suite 150, Roseville, CA 95678',
    phone: '(916) 555-1145',
    website: 'https://luxesalonroseville.com',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20modern%20salon%20and%20spa%20interior%20with%20elegant%20styling%20stations%20large%20mirrors%20warm%20ambient%20lighting%20marble%20countertops%20fresh%20flowers%20and%20plush%20seating%20upscale%20beauty%20salon%20atmosphere&width=600&height=400&seq=dir13&orientation=landscape',
    logo: 'ri-scissors-line',
    rating: 4.8,
    reviews: 267,
    featured: true,
    verified: true,
    offer: '20% Off First Service',
    openNow: true,
    hours: 'Tue-Sat 9AM-7PM',
    priceRange: '$$$',
    yearEstablished: 2014,
    lastVerified: 'Mar 9, 2025',
  },
  {
    id: 14,
    name: 'Roseville Learning Academy',
    tagline: 'Empowering young minds',
    category: 'education',
    description: 'Private tutoring center offering K-12 academic support, SAT/ACT prep, coding classes, and enrichment programs. Certified teachers with personalized learning plans.',
    address: '3050 Secret Ravine Pkwy, Roseville, CA 95747',
    phone: '(916) 555-1267',
    website: 'https://rosevillelearning.com',
    image: 'https://readdy.ai/api/search-image?query=bright%20modern%20tutoring%20center%20interior%20with%20colorful%20learning%20stations%20bookshelves%20computers%20and%20educational%20posters%20clean%20organized%20classroom%20space%20with%20natural%20light%20welcoming%20educational%20environment&width=600&height=400&seq=dir14&orientation=landscape',
    logo: 'ri-book-open-line',
    rating: 4.9,
    reviews: 89,
    featured: false,
    verified: true,
    offer: 'Free Assessment Session',
    openNow: false,
    hours: 'Mon-Fri 3PM-8PM, Sat 9AM-3PM',
    priceRange: '$$',
    yearEstablished: 2016,
    lastVerified: 'Feb 18, 2025',
  },
  {
    id: 15,
    name: 'Heritage Home Remodeling',
    tagline: 'Transforming houses into dream homes',
    category: 'home',
    description: 'Licensed general contractor specializing in kitchen and bathroom remodels, room additions, and whole-home renovations. 3D design previews and transparent pricing.',
    address: '4500 Granite Dr Suite 100, Roseville, CA 95747',
    phone: '(916) 555-1389',
    website: 'https://heritagehomeroseville.com',
    image: 'https://readdy.ai/api/search-image?query=stunning%20modern%20kitchen%20remodel%20with%20white%20cabinets%20marble%20countertops%20stainless%20steel%20appliances%20pendant%20lighting%20over%20island%20bright%20airy%20California%20home%20renovation%20professional%20interior%20design&width=600&height=400&seq=dir15&orientation=landscape',
    logo: 'ri-hammer-line',
    rating: 4.8,
    reviews: 76,
    featured: false,
    verified: true,
    offer: 'Free In-Home Estimate',
    openNow: false,
    hours: 'Mon-Fri 8AM-5PM',
    priceRange: '$$$',
    yearEstablished: 2007,
    lastVerified: 'Mar 3, 2025',
  },
  {
    id: 16,
    name: 'Roseville Insurance Group',
    tagline: 'Protecting what matters most',
    category: 'professional',
    description: 'Independent insurance agency offering home, auto, life, and business insurance from top-rated carriers. Free quotes and annual policy reviews for all clients.',
    address: '1700 Eureka Rd Suite 310, Roseville, CA 95661',
    phone: '(916) 555-1456',
    website: 'https://rosevilleinsurance.com',
    image: 'https://readdy.ai/api/search-image?query=professional%20insurance%20office%20interior%20with%20modern%20furniture%20comfortable%20consultation%20area%20framed%20certificates%20on%20wall%20clean%20corporate%20design%20with%20warm%20neutral%20tones%20welcoming%20business%20atmosphere&width=600&height=400&seq=dir16&orientation=landscape',
    logo: 'ri-shield-check-line',
    rating: 4.7,
    reviews: 112,
    featured: false,
    verified: true,
    offer: '',
    openNow: false,
    hours: 'Mon-Fri 8:30AM-5:30PM',
    priceRange: '$$',
    yearEstablished: 2001,
    lastVerified: 'Feb 10, 2025',
  },
  {
    id: 17,
    name: 'The Rustic Table',
    tagline: 'Farm-to-fork California cuisine',
    category: 'restaurant',
    description: 'Farm-to-table restaurant featuring seasonal menus with locally sourced ingredients. Weekend brunch, craft cocktails, and a beautiful garden patio for al fresco dining.',
    address: '320 Lincoln St, Roseville, CA 95678',
    phone: '(916) 555-1578',
    website: 'https://rustictableroseville.com',
    image: 'https://readdy.ai/api/search-image?query=charming%20farm%20to%20table%20restaurant%20interior%20with%20rustic%20wooden%20tables%20fresh%20herb%20centerpieces%20exposed%20beam%20ceiling%20warm%20Edison%20bulb%20lighting%20open%20kitchen%20concept%20California%20casual%20fine%20dining&width=600&height=400&seq=dir17&orientation=landscape',
    logo: 'ri-restaurant-line',
    rating: 4.8,
    reviews: 298,
    featured: false,
    verified: false,
    offer: 'Prix Fixe Dinner $45',
    openNow: true,
    hours: 'Tue-Sun 11AM-10PM',
    priceRange: '$$$',
    yearEstablished: 2021,
    lastVerified: 'Jan 15, 2025',
  },
  {
    id: 18,
    name: 'Roseville Vintage Market',
    tagline: 'Treasures from every era',
    category: 'retail',
    description: 'Curated vintage and antique marketplace featuring furniture, clothing, vinyl records, and collectibles from over 40 local vendors. New arrivals weekly.',
    address: '225 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-1690',
    website: 'https://rosevillevintage.com',
    image: 'https://readdy.ai/api/search-image?query=eclectic%20vintage%20market%20interior%20with%20antique%20furniture%20vinyl%20records%20retro%20clothing%20racks%20and%20collectibles%20displayed%20artfully%20warm%20lighting%20exposed%20brick%20walls%20charming%20bohemian%20shopping%20atmosphere&width=600&height=400&seq=dir18&orientation=landscape',
    logo: 'ri-store-3-line',
    rating: 4.6,
    reviews: 203,
    featured: false,
    verified: false,
    offer: '',
    openNow: true,
    hours: 'Thu-Sun 10AM-6PM',
    priceRange: '$',
    yearEstablished: 2022,
    lastVerified: 'Jan 8, 2025',
  },
];
